<template slot:header>
  <!--Menu for mobile devices-->
  <div id="menu--bar">
    <img
      v-if="isMobile()"
      @click="goToHome"
      src="../assets/img/assuraf_white.png"
      width="150"
      alt="logo assuraf"
    />

    <v-toolbar
      color="#333"
      fixed
      class="elevation-18 extended mb-5"
      v-if="allowbuttondownload"
      style="height: 70px !important; z-index: 3"
    >
      <v-flex class="row" v-responsive.lg.xl>
        <p style="color: white; padding-left: 8%; padding-top: 5px !important">
          {{ $t('menu.download_app_description_desktop[0]') }}
          <span class="font-weight-bold" style="color: #ffa409">{{
            $t('menu.download_app_description_desktop[1]')
          }}</span>
        </p>
        <ul class="mb-3 list-group full-width" style="display: contents; margin-top: 10px">
          <li class="ml-3">
            <a
              href="https://play.google.com/store/apps/details?id=com.afdecoding.assurafmobile"
              target="_blank"
            >
              <img src="../assets/img/logo_playStore.png" width="120" alt="assuraf_playstor" />
            </a>
          </li>

          <li class="ml-3">
            <a href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr" target="_blank">
              <img src="../assets/img/logo-appStore.png" width="120" alt="assuraf_playstor" />
            </a>
          </li>
        </ul>
      </v-flex>
      <v-flex v-responsive.md v-responsive.sm.xs class="justify-content-center row">
        <div class="row justify-content-center">
          <p style="color: white; padding-top: 10px !important">
            {{ $t('menu.download_app_description_mobile[0]') }}
            <span class="font-weight-bold" style="color: #ffa409">{{
              $t('menu.download_app_description_mobile[1]')
            }}</span>
          </p>
        </div>

        <div class="row justify-content-center" style="margin-top: -10px">
          <ul
            class="mb-5 list-group full-width"
            style="display: contents !important; margin-top: -15px"
          >
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.afdecoding.assurafmobile"
                target="_blank"
              >
                <img src="../assets/img/logo_playStore.png" width="100" alt="assuraf_playstor" />
              </a>
            </li>

            <li class="ml-3">
              <a href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr" target="_blank">
                <img src="../assets/img/logo-appStore.png" width="100" alt="assuraf_playstor" />
              </a>
            </li>
          </ul>
        </div>
      </v-flex>
    </v-toolbar>

    <v-toolbar
      id="allowMargin"
      color="#FFF"
      fixed
      class="allowMarginStyle elevation-18 extended mb-5"
      style="z-index: 3"
    >
      <v-flex class="to_left" v-if="isMobile()">
        <v-btn
          flat
          icon
          round
          medium
          class="login-btn-mobile"
          v-if="!this.$store.state.isUserLoggedIn"
          @click.stop="LoadPopupMobileLeft()"
        >
          <i class="material-icons" aria-hidden="true" data-nosnippet>&#xe853;</i>
        </v-btn>
        <v-menu offset-y v-if="this.$store.state.isUserLoggedIn">
          <v-btn flat icon round medium class="login-btn-mobile-connect" slot="activator"
            ><i class="material-icons icon-menu" aria-hidden="true" data-nosnippet>&#xe853;</i>
          </v-btn>
          <v-list class="policeLato border-radius elevation-24">
            <v-list-tile @click="toDashboard">
              <v-list-tile-title style="color: #ffa409">
                {{ $t('menu.Login[0]') }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click.stop="logout">
              <v-list-tile-title>
                {{ $t('menu.Login[1]') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <v-toolbar-title v-if="isDesktop()" style="padding-left: 8%">
        <router-link to="/" tag="span" style="cursor: pointer">
          <img src="../assets/img/assuraf_sm.png" width="75%" alt="logo assuraf" />
        </router-link>
      </v-toolbar-title>

      <v-toolbar-title v-if="isMobile()">
        <router-link to="/" tag="span" style="cursor: pointer">
          <img
            src="../assets/img/assuraf_sm.png"
            width="60%"
            alt="logo assuraf"
            class="ml-5 pl-3"
          />
        </router-link>
      </v-toolbar-title>

      <v-toolbar-title v-if="isMobile() && Mano2 > 0">
        <v-btn icon small flat @click="RedirectionPaiemtnDiffere">
          <v-icon color="red">&#xe906;</v-icon>
        </v-btn>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down policeLato mt-3" style="padding-right: 5%">
        <!-- <button id="Assurance" v-if="hideMenu" style="margin-right:-5px">
                    <span>{{ $t('menu.Assurances[0]') }}<i style="font-size: 13px" class="ml-2 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24" style="width: auto">
                        <li><a href="/assurance/Auto-Moto">{{ $t('menu.Assurances[1]') }}</a></li>
                        <li><a href="/assurance/Habitation">{{ $t('menu.Assurances[2]') }}</a></li>
                        <li><a href="/assurance/Voyage">{{ $t('menu.Assurances[3]') }}</a></li>
                        <li @click="showEntityHealthFunction()" style="position: relative;">
                            {{ $t('menu.Assurances[4]') }}
                            <i v-if="showEntityHealth!=true" class="fas fa-chevron-down" style="font-size: 12px; margin-left: 5px;"></i>
                            <i v-if="showEntityHealth!=false"class="fas fa-chevron-up" style="font-size: 12px; margin-left: 5px;"></i>
                        </li>
                        <li v-if="showEntityHealth"><a href="/assurance/Sante/entreprise">{{ $t('menu.Assurances[8]') }}</a></li>
                        <li v-if="showEntityHealth"><a href="/assurance/Sante">{{ $t('menu.Assurances[9]') }}</a></li>
                        <li><a href="/assurance/Vie">{{ $t('menu.Assurances[5]') }}</a></li>
                        <li><a href="/assurance/Assurplus">{{ $t('menu.Assurances[6]') }}</a></li>
                        <li><a href="/assurance/sinistre">{{ $t('menu.Assurances[7]') }}</a></li>
                    </ul>
                </button> -->

        <button
          id="Assurance"
          v-if="hideMenu"
          style="margin-left: -100px; margin-top: 10px; font-size: 14px; position: absolute"
        >
          <span style="margin-top: -8px !important"
            ><a href="/apropos">{{ $t('menu.A_propos[0]') }}</a
            ><i style="font-size: 13px" class="ml-2 fas fa-chevron-down"></i
          ></span>
          <ul class="devis elevation-24">
            <li>
              <a href="/apropos#histoire">{{ $t('menu.A_propos[1]') }}</a>
            </li>
            <li>
              <a href="/apropos#valeurs">{{ $t('menu.A_propos[2]') }}</a>
            </li>
            <li>
              <a href="/apropos#faq">{{ $t('menu.A_propos[3]') }}</a>
            </li>
            <li @click="showEntityInsurancesFunction()" style="position: relative">
              {{ $t('menu.Assurances[0]') }}
              <i
                v-if="showEntityInsurances != true"
                class="fas fa-chevron-down"
                style="font-size: 12px; margin-left: 5px"
              ></i>
              <i
                v-if="showEntityInsurances != false"
                class="fas fa-chevron-up"
                style="font-size: 12px; margin-left: 5px"
              ></i>
            </li>

            <li v-if="showEntityInsurances">
              <a href="/assurance/Auto-Moto">{{ $t('menu.Assurances[1]') }}</a>
            </li>
            <li v-if="showEntityInsurances">
              <a href="/assurance/Habitation">{{ $t('menu.Assurances[2]') }}</a>
            </li>
            <li v-if="showEntityInsurances">
              <a href="/assurance/Voyage">{{ $t('menu.Assurances[3]') }}</a>
            </li>
            <li
              v-if="showEntityInsurances"
              @click="showEntityHealthFunction()"
              style="position: relative"
            >
              {{ $t('menu.Assurances[4]') }}
              <i
                v-if="showEntityHealth != true"
                class="fas fa-chevron-down"
                style="font-size: 12px; margin-left: 5px"
              ></i>
              <i
                v-if="showEntityHealth != false"
                class="fas fa-chevron-up"
                style="font-size: 12px; margin-left: 5px"
              ></i>
            </li>
            <li v-if="showEntityHealth">
              <a href="/assurance/Sante/entreprise">{{ $t('menu.Assurances[8]') }}</a>
            </li>
            <li v-if="showEntityHealth">
              <a href="/assurance/Sante">{{ $t('menu.Assurances[9]') }}</a>
            </li>
            <li v-if="showEntityInsurances">
              <a href="/assurance/Vie">{{ $t('menu.Assurances[5]') }}</a>
            </li>
            <li v-if="showEntityInsurances">
              <a href="/assurance/Assurplus">{{ $t('menu.Assurances[6]') }}</a>
            </li>
            <li v-if="showEntityInsurances">
              <a href="/assurance/sinistre">{{ $t('menu.Assurances[7]') }}</a>
            </li>
          </ul>
        </button>

        <v-btn
          v-if="hideMenu"
          style="margin-right: -10px; margin-top: -5px; border-radius: 22px; font-size: 14px"
          flat
          round
          medium
          href="/ContactForm"
          class="to-grey"
          >{{ $t('menu.Contact') }}</v-btn
        >
        <v-btn
          @click="toSinistre"
          v-if="hideMenu"
          style="margin-right: -10px; margin-top: -5px; border-radius: 22px; font-size: 14px"
          flat
          round
          medium
          href="javascript:void(0)"
          class="to-grey"
          >{{ $t('menu.sinistre_label') }}</v-btn
        >

        <!-- <v-menu offset-y v-if="this.$store.state.isUserLoggedIn">
                    <v-btn color="#ffa409" slot="activator" flat medium icon style="border-radius: 22px;font-weight: 500">
                        <div class="pictos">
                            <a class="picto-item" href="javascript:void(0)" :aria-label="username"><span style="font-size: 13px;">{{ username.split(' ').map(word => word[0]).join('') }}</span></a>
                        </div>

                    </v-btn>

                    <v-list shaped class="policeLato border-radius elevation-24">
                        <v-list-tile @click="toDashboard">
                            <v-list-tile-title style="font-size:14px;color:#ffa409">
                                {{ $t('menu.Login[0]') }}
                            </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile @click.stop="logout">
                            <v-list-tile-title style="font-size:14px">
                                {{ $t('menu.Login[1]') }}
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu> -->

        <!-- style="overflow-y: scroll; height:200px;" -->

        <!-- <button @click="goToSimAuto" v-if="hideMenu" class="ml-3 trigger-simulation">
                    <span>
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5023 14.3674L20.5319 9.35289C21.2563 8.63072 21.6185 8.26963 21.8092 7.81046C22 7.3513 22 6.84065 22 5.81937V5.33146C22 3.76099 22 2.97576 21.5106 2.48788C21.0213 2 20.2337 2 18.6585 2H18.1691C17.1447 2 16.6325 2 16.172 2.19019C15.7114 2.38039 15.3493 2.74147 14.6249 3.46364L9.59522 8.47817C8.74882 9.32202 8.224 9.84526 8.02078 10.3506C7.95657 10.5103 7.92446 10.6682 7.92446 10.8339C7.92446 11.5238 8.48138 12.0791 9.59522 13.1896L9.74492 13.3388L11.4985 11.5591C11.7486 11.3053 12.1571 11.3022 12.4109 11.5523C12.6647 11.8024 12.6678 12.2109 12.4177 12.4647L10.6587 14.2499L10.7766 14.3674C11.8905 15.4779 12.4474 16.0331 13.1394 16.0331C13.2924 16.0331 13.4387 16.006 13.5858 15.9518C14.1048 15.7607 14.6345 15.2325 15.5023 14.3674ZM17.8652 8.47854C17.2127 9.12904 16.1548 9.12904 15.5024 8.47854C14.8499 7.82803 14.8499 6.77335 15.5024 6.12284C16.1548 5.47233 17.2127 5.47233 17.8652 6.12284C18.5177 6.77335 18.5177 7.82803 17.8652 8.47854Z" fill="#fff"></path> 
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.77409 12.4814C3.07033 12.778 3.07004 13.2586 2.77343 13.5548L2.61779 13.7103C2.48483 13.8431 2.48483 14.058 2.61779 14.1908C2.75125 14.3241 2.96801 14.3241 3.10147 14.1908L4.8136 12.4807C5.1102 12.1845 5.59079 12.1848 5.88704 12.4814C6.18328 12.778 6.18298 13.2586 5.88638 13.5548L4.17426 15.2648C3.4481 15.9901 2.27116 15.9901 1.545 15.2648C0.818334 14.5391 0.818333 13.362 1.545 12.6362L1.70065 12.4807C1.99725 12.1845 2.47784 12.1848 2.77409 12.4814ZM7.29719 16.696C7.5903 16.9957 7.58495 17.4762 7.28525 17.7693L5.55508 19.4614C5.25538 19.7545 4.77481 19.7491 4.48171 19.4494C4.1886 19.1497 4.19395 18.6692 4.49365 18.3761L6.22382 16.684C6.52352 16.3909 7.00409 16.3963 7.29719 16.696ZM11.4811 18.118C11.7774 18.4146 11.7771 18.8952 11.4805 19.1915L9.76834 20.9015C9.63539 21.0343 9.63539 21.2492 9.76834 21.382C9.9018 21.5153 10.1186 21.5153 10.252 21.382L10.4077 21.2265C10.7043 20.9303 11.1849 20.9306 11.4811 21.2272C11.7774 21.5238 11.7771 22.0044 11.4805 22.3006L11.3248 22.4561C10.5987 23.1813 9.42171 23.1813 8.69556 22.4561C7.96889 21.7303 7.96889 20.5532 8.69556 19.8274L10.4077 18.1174C10.7043 17.8211 11.1849 17.8214 11.4811 18.118Z" fill="#fff"></path> 
                                <g opacity="0.5"> <path d="M10.8461 5.40925L8.65837 7.59037C8.25624 7.99126 7.88737 8.35901 7.59606 8.69145C7.40899 8.90494 7.22204 9.13861 7.06368 9.39679L7.04237 9.37554C7.00191 9.3352 6.98165 9.31501 6.96133 9.29529C6.58108 8.92635 6.1338 8.63301 5.64342 8.43097C5.61722 8.42018 5.59062 8.40964 5.53743 8.38856L5.2117 8.25949C4.77043 8.08464 4.65283 7.51659 4.9886 7.18184C5.95224 6.22112 7.10923 5.06765 7.6676 4.83597C8.16004 4.63166 8.692 4.56368 9.20505 4.6395C9.67514 4.70897 10.1198 4.95043 10.8461 5.40925Z" fill="#fff"></path> <path d="M14.5816 16.8934C14.7579 17.0723 14.8749 17.1987 14.9808 17.3337C15.1204 17.5119 15.2453 17.7012 15.3542 17.8996C15.4767 18.123 15.5718 18.3616 15.7621 18.8389C15.9169 19.2274 16.4315 19.3301 16.7303 19.0322L16.8026 18.9601C17.7662 17.9993 18.9232 16.8458 19.1556 16.2891C19.3605 15.7982 19.4287 15.2678 19.3526 14.7563C19.283 14.2877 19.0408 13.8444 18.5807 13.1205L16.3857 15.3089C15.9745 15.7189 15.5974 16.0949 15.2564 16.3894C15.052 16.5659 14.8284 16.7423 14.5816 16.8934Z" fill="#fff"></path> </g> <g opacity="0.5"> <path d="M7.68621 14.5633C7.98263 14.2669 7.98263 13.7863 7.68621 13.4899C7.38979 13.1935 6.90919 13.1935 6.61277 13.4899L4.47036 15.6323C4.17394 15.9287 4.17394 16.4093 4.47036 16.7057C4.76679 17.0021 5.24738 17.0021 5.5438 16.7057L7.68621 14.5633Z" fill="#fff"></path> <path d="M10.4954 17.369C10.7918 17.0726 10.7918 16.592 10.4954 16.2956C10.1989 15.9992 9.71835 15.9992 9.42193 16.2956L7.29417 18.4233C6.99774 18.7198 6.99774 19.2003 7.29417 19.4968C7.59059 19.7932 8.07118 19.7932 8.36761 19.4968L10.4954 17.369Z" fill="#fff"></path> </g> </g></svg>

                        {{ $t('home_page.bouton_simulation_view') }}
                    </span>
                </button> -->

        <button v-if="hideMenu" class="trigger-simulation" style="margin-left: 25px">
          <span>
            <img
              class="mr-3"
              loading="lazy"
              src="../assets/img/rocket.png"
              width="20px"
              alt="writing quotes" />

            <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
            {{ $t('home_page.bouton_simulation_view')
            }}<i style="font-size: 15px" class="ml-3 fas fa-chevron-down"></i
          ></span>
          <ul class="devis elevation-24">
            <li>
              <a class="hiddenParticulier" href="/simulate/devis/auto"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/cars_quote.png"
                    alt="devis_auto" /></i
                >{{ $t('menu.Devis[1]') }}</a
              >
            </li>
            <li>
              <a href="/simulate/devis/voyage"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/travel_quote.png"
                    alt="devis_habitation" /></i
                >{{ $t('menu.Devis[3]') }}</a
              >
            </li>
          </ul>
        </button>

        <button v-if="hideMenu" class="trigger" style="margin-left: 40px">
          <span>
            <img
              class="mr-3"
              loading="lazy"
              src="../assets/img/writing.png"
              width="20px"
              alt="writing quotes" />

            <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
            {{ $t('menu.Devis[0]') }}<i style="font-size: 15px" class="ml-3 fas fa-chevron-down"></i
          ></span>
          <ul class="devis elevation-24">
            <li class="font-weight-bold">Particulier</li>
            <li>
              <a class="hiddenParticulier" href="/devis/auto"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/cars_quote.png"
                    alt="devis_auto" /></i
                >{{ $t('menu.Devis[1]') }}</a
              >
            </li>
            <li>
              <a href="/devis/habitation"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/house_quote.png"
                    alt="devis_habitation" /></i
                >{{ $t('menu.Devis[2]') }}</a
              >
            </li>
            <li>
              <a href="/devis/voyage"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/travel_quote.png"
                    alt="devis_voyage" /></i
                >{{ $t('menu.Devis[3]') }}</a
              >
            </li>
            <li>
              <a href="/devis/sante"
                ><i
                  ><img
                    class="mr-2"
                    width="40"
                    src="../assets/img/icones/menu/health_quote.png"
                    alt="devis_sante" /></i
                >{{ $t('menu.Devis[4]') }}</a
              >
            </li>
            <li>
              <a href="/devis/vie"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/life_quote.png"
                    alt="devis_vie" /></i
                >{{ $t('menu.Devis[5]') }}</a
              >
            </li>
            <li>
              <a href="/plus"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/add_quote.png"
                    alt="devis_plus" /></i
                >{{ $t('menu.Devis[6]') }}</a
              >
            </li>
            <li class="font-weight-bold">Entreprise</li>
            <li>
              <a href="/flotte/entreprise"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/menu/cars_quote.png"
                    alt="flotte" /></i
                >{{ $t('menu.Devis[7]') }}</a
              >
            </li>
            <li>
              <a href="/devis/mrp"
                ><i
                  ><img
                    class="mr-2"
                    width="25"
                    src="../assets/img/icones/menu/mrp_quote.png"
                    alt="devis_mrp"
                /></i>
                MRP</a
              >
            </li>
            <li>
              <a href="/devis/trc"
                ><i
                  ><img
                    class="mr-2"
                    width="30"
                    src="../assets/img/icones/menu/trc_quote.png"
                    alt="devis_trc" /></i
                >TRC</a
              >
            </li>
            <li>
              <a href="/rcscolaire"
                ><i
                  ><img
                    class="mr-2"
                    width="35"
                    src="../assets/img/icones/rcscolaire.png"
                    alt="flotte" /></i
                >{{ $t('menu.Devis[8]') }}</a
              >
            </li>
          </ul>
        </button>

        <v-menu
          offset-y
          v-if="this.$store.state.isUserLoggedIn"
          style="margin-left: 35px; margin-top: -5px"
        >
          <v-btn
            color="#ffa409"
            slot="activator"
            flat
            medium
            icon
            style="border-radius: 22px; font-weight: 500"
          >
            <div class="pictos">
              <a class="picto-item" href="javascript:void(0)" :aria-label="username"
                ><span style="font-size: 13px">{{
                  username
                    .split(' ')
                    .map((word) => word[0])
                    .join('')
                }}</span></a
              >
            </div>
          </v-btn>

          <v-list shaped class="policeLato border-radius elevation-24">
            <v-list-tile @click="toDashboard">
              <v-list-tile-title style="font-size: 14px; color: #ffa409">
                {{ $t('menu.Login[0]') }}
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click.stop="logout">
              <v-list-tile-title style="font-size: 14px">
                {{ $t('menu.Login[1]') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <!-- <select id="select_menu" class="language" style="border:1.5px solid #ffa409;font-size: 14px;margin-left: 10px;" @change="updateLanguage" v-model="$i18n.locale">
                    <option data-display="French (FR)" value="FR">FR</option>
                    <option data-display="English (EN)" value="EN">EN</option>
                </select> -->

        <v-btn
          flat
          round
          medium
          class="login-btn"
          style="border: none !important; margin-top: 3px; margin-left: 30px"
          v-if="!this.$store.state.isUserLoggedIn"
          @click.stop="LoadLoginPopupDesktop()"
          >Login</v-btn
        >

        <select
          aria-label="language_select"
          @change="updateLanguage"
          v-model="$i18n.locale"
          v-if="this.$store.state.isUserLoggedIn"
        >
          <option value="FR" name="language_select">🇫🇷 FR</option>
          <option value="EN" name="language_select">🇺🇸 ENG</option>
        </select>
        <select
          aria-label="language_select"
          @change="updateLanguage"
          v-model="$i18n.locale"
          v-else
          style="margin-left: -15px"
        >
          <option value="FR" name="language_select">🇫🇷 FR</option>
          <option value="EN" name="language_select">🇺🇸 ENG</option>
        </select>

        <!-- ================ ICON  ==================-->
        <v-btn
          icon
          small
          flat
          style="margin-right: -10px"
          @click="RedirectionPaiemtnDiffere"
          v-if="Mano2 > 0"
        >
          <v-icon color="red">&#xe906;</v-icon>
        </v-btn>

        <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
      </div>

      <!-- <v-toolbar-side-icon class="menu-button" clipped-right @click="sideNav = true" ></v-toolbar-side-icon> -->

      <div v-if="isMobile()">
        <div class="phone">
          <div class="top-bar">
            <a href="javascript:void(0)" class="menu-button" data-text-swap="Fermer">
              <v-toolbar-side-icon clipped-right class="hidden-md-and-up"></v-toolbar-side-icon
            ></a>
            <div class="menu" style="overflow-y: auto; max-height: 100vh">
              <div>
                <!-- =================== Menu deroulant Devis =====================-->
                <v-list class="pt-0" style="margin-top: 20%">
                  <v-list-group>
                    <v-list-tile slot="activator">
                      <v-icon>&#xe8d2;</v-icon>
                      <v-list-tile-title
                        class="policeLato"
                        style="
                          padding-left: 32px;
                          color: #ffa409;
                          font-weight: 500;
                          font-size: 22px;
                        "
                        >{{ $t('home_page.bouton_devis[0]') }}
                      </v-list-tile-title>
                    </v-list-tile>
                    <p class="ml-4 mt-3" style="font-size: 24px">Particulier</p>
                    <v-list-tile
                      v-for="item in $t('menu.DevisItems')"
                      :key="item.title"
                      :to="item.link"
                    >
                      <v-list-tile-action @click="link_menu_onclick(item.title)">
                        <v-list-tile-title class="tile policeLato">
                          <img
                            class="mr-2"
                            width="30"
                            :src="loadImg(item.imagePath)"
                            :alt="item.title"
                          />
                          {{ item.title }}
                        </v-list-tile-title>
                      </v-list-tile-action>
                    </v-list-tile>

                    <p class="ml-4 mt-3" style="font-size: 24px">Entreprise</p>
                    <v-list-tile>
                      <v-list-tile-action @click="toDevisFlotte()">
                        <v-list-tile-title class="tile policeLato"
                          ><i
                            ><img
                              class="mr-2"
                              width="30"
                              src="../assets/img/icones/menu/cars_quote.png"
                              alt="devis_mrp" /></i
                          >{{ $t('menu.Devis[7]') }}</v-list-tile-title
                        >
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-action @click="toDevisMrp()">
                        <v-list-tile-title class="tile policeLato"
                          ><i
                            ><img
                              class="mr-2"
                              width="30"
                              src="../assets/img/icones/menu/mrp_quote.png"
                              alt="devis_mrp" /></i
                          >MRP</v-list-tile-title
                        >
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-action @click="toDevisTrc()">
                        <v-list-tile-title class="tile policeLato"
                          ><i
                            ><img
                              class="mr-2"
                              width="30"
                              src="../assets/img/icones/menu/trc_quote.png"
                              alt="devis_mrp" /></i
                          >TRC</v-list-tile-title
                        >
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-action @click="toRcScolaire()">
                        <v-list-tile-title class="tile policeLato"
                          ><i
                            ><img
                              class="mr-2"
                              width="30"
                              src="../assets/img/icones/rcscolaire.png"
                              alt="devis_mrp" /></i
                          >{{ $t('menu.Devis[8]') }}</v-list-tile-title
                        >
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list-group>
                </v-list>

                <!-- =================== Menu deroulant Simulation =====================-->
                <v-list class="pt-0" style="margin-top: -10px">
                  <v-list-group>
                    <v-list-tile slot="activator">
                      <!-- Utilisez un filtre CSS pour rendre l'image orange -->
                      <img
                        loading="lazy"
                        src="../assets/img/rocket.png"
                        width="23px"
                        alt="writing quotes"
                        style="
                          filter: brightness(0) saturate(100%) invert(62%) sepia(81%) saturate(749%)
                            hue-rotate(359deg) brightness(101%) contrast(101%);
                        "
                      />

                      <!-- <v-icon>&#xe8d2;</v-icon> -->
                      <v-list-tile-title
                        class="policeLato"
                        style="padding-left: 32px; font-weight: 500; font-size: 22px"
                        >Simulation Express
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-for="item in $t('menu.SimulationItems')"
                      :key="item.title"
                      :to="item.link"
                    >
                      <v-list-tile-action @click="link_menu_onclick(item.title)">
                        <v-list-tile-title class="tile policeLato">
                          <img
                            class="mr-2"
                            width="30"
                            :alt="item.title"
                            :src="loadImg(item.imagePath)"
                          />
                          {{ item.title }}
                        </v-list-tile-title>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list-group>
                </v-list>
                <!-- =================== Menu deroulant Assurance =====================-->
                <v-list class="pt-1">
                  <v-list-group style="margin-top: -10px">
                    <v-list-tile slot="activator">
                      <v-icon>&#xe92c;</v-icon>
                      <v-list-tile-title
                        class="policeLato"
                        style="padding-left: 32px; font-weight: 500; font-size: 22px"
                        >{{ $t('menu.Assurances[0]') }}
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-for="item in $t('menu.AssuranceItems')"
                      :key="item.title"
                      :to="item.link"
                      @click="closeMenuBurger"
                    >
                      <v-list-tile-action>
                        <v-list-tile-title class="tile policeLato">
                          {{ item.title }}
                        </v-list-tile-title>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list-group>
                </v-list>
                <!-- =================== Déclaration sinistre =====================-->
                <v-list style="margin-top: -10px">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon>&#xe85d;</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        @click="toSinistre()"
                        class="tile policeLato"
                        style="font-weight: 500; font-size: 22px"
                        >{{ $t('menu.sinistre_label') }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

                <!-- =================== Menu sans deroulant =====================-->
                <v-list style="margin-top: -10px">
                  <v-list-tile
                    v-for="item in $t('menu.menuItems')"
                    :key="item.title"
                    :to="item.link"
                    @click="closeMenuBurger"
                  >
                    <v-list-tile-action>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="tile policeLato"
                        style="font-weight: 500; font-size: 22px"
                        >{{ item.title }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

                <!-- =================== Menu sans deroulant suite =====================-->
                <v-list style="margin-top: -10px">
                  <v-list-tile
                    v-for="item in $t('menu.menuItems2')"
                    :key="item.title"
                    :to="item.link"
                    @click="ContactEntryPoint('menu')"
                  >
                    <v-list-tile-action>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="tile policeLato"
                        style="font-weight: 500; font-size: 22px"
                        >{{ item.title }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

                <!-- =================== Redirection vers la page dashbord en fonction de l'etat du User =====================-->
                <v-list style="margin-top: -10px" v-if="!this.$store.state.isUserLoggedIn">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon>&#xe8a6;</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        @click="RedirectionEspaceAssure()"
                        class="tile policeLato"
                        style="font-weight: 500; font-size: 22px"
                        >Login
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

                <!-- =================== Redirection vers la page dashbord en fonction de l'etat du User =====================-->
                <v-list style="margin-top: -10px" v-if="this.$store.state.isUserLoggedIn">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon>&#xe8a6;</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        @click="RedirectionEspaceAssure()"
                        class="tile policeLato"
                        style="font-weight: 500; font-size: 22px"
                        >{{ $t('menu.Login[0]') }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

                <v-list>
                  <v-list-tile>
                    <!-- <v-list-tile-action>
                            <v-icon>&#xe865;</v-icon>
                        </v-list-tile-action> -->
                    <v-list-tile-content>
                      <!-- <select id="select_menu" class="language" style="border:1px solid #ffa409;" @change="updateLanguage" v-model="$i18n.locale">
                                <option data-display="French (FR)" value="FR">French (FR)</option>
                                <option data-display="English (EN)" value="EN">English (EN)</option>
                            </select> -->
                      <select
                        aria-label="language_select"
                        @change="updateLanguage"
                        v-model="$i18n.locale"
                      >
                        <option value="FR" name="language_select_mobile">🇫🇷 FR</option>
                        <option value="EN" name="language_select_mobile">🇺🇸 ENG</option>
                      </select>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <v-toolbar-side-icon clipped-right @click.native.stop="sideNav = !sideNav" class="hidden-md-and-up"></v-toolbar-side-icon> -->
    </v-toolbar>

    <div v-show="isDesktopWhatsapp" :style="whatsappFloatStyle">
      <div id="floating_bouton" v-show="allowIconSinitre">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a @click="toSinistre()" title="Déclarer sinistre"
                ><img
                  src="../assets/img/home/new_home/sinistreKiray.png"
                  class="img-fluid mob-what"
                  alt="kirray_sinistre"
                  width="77"
              /></a>
            </div>
          </div>
        </section>
      </div>

      <div
        :id="isWhatsappExcludedPage ? undefined : 'floating_bouton_whatsapp'"
        :class="isWhatsappExcludedPage ? 'floating_bouton_whatsapp' : ''"
      >
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a
                href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋"
                target="_blank"
                rel="nofollow noopener noreferrer"
                ><img
                  src="../assets/img/home/new_home/WhatsApp_icon.png"
                  class="mr-2 img-fluid mob-what"
                  alt="whatsapp_icon"
                  width="70"
              /></a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div v-show="isMobileWhatsapp">
      <div id="floating_bouton_mobile" v-show="allowIconSinitre">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a @click="toSinistre()" title="Déclarer sinistre"
                ><img
                  src="../assets/img/home/new_home/sinistreKiray.png"
                  class="img-fluid mob-what"
                  alt="kirray_sinistre"
                  width="75"
              /></a>
            </div>
          </div>
        </section>
      </div>

      <div id="floating_bouton_whatsapp_mobile">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a
                href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋"
                target="_blank"
                rel="nofollow noopener noreferrer"
                ><img
                  src="../assets/img/home/new_home/WhatsApp_icon.png"
                  class="img-fluid mob-what"
                  alt="whatsapp_icon"
                  width="70"
              /></a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
  </div>
</template>

<script>
import AuthService from './../services/AuthenticationService';
import Api from './../services/Api';
import { mapGetters } from 'vuex';
//import AnchorRouterLink from 'vue-anchor-router-link'
import store from '../store/store';
import PushInDataLayer from '../services/TagManager';
import LoginForm from './auth/Login';
import $ from 'jquery';

const images = require.context('@/assets/img/icones/menu/', false, /\.png$|\.jpg$/);

export default {
  name: 'Menu',
  components: {
    LoginForm
    //AnchorRouterLink,
  },
  data: function () {
    return {
      showEntityHealth: false,
      showEntityInsurances: false,
      isMobileWhatsapp: false,
      isDesktopWhatsapp: false,
      allowbuttondownload: true,
      allowIconSinitre: true,
      partnerCode: process.env.VUE_APP_CODEP, //process.env.VUE_APP_CODEP,//"LOK839",//
      hideMenu: true,
      langs: ['FR', 'EN'],
      fav: true,
      menu: false,
      hints: true,
      loggedUser: '',
      Mano: null,
      Mano2: 0,
      demo: 0,
      showLoginForm: false,
      sideNav: false,
      drawer: true,
      password_new: null,
      LoginDialog: false,
      verifBranche: null,
      menuItems: [
        {
          title: 'A propos',
          link: '/apropos',
          icon: 'question_answer',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      menuItems1: [
        {
          title: 'Contact',
          link: '/#ContactForm',
          icon: 'call',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      menuItems2: [
        {
          title: 'Contact',
          link: '/ContactForm',
          icon: 'call',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      //Devis menu
      DevisItems: [
        {
          title: 'Auto/Moto',
          link: '/devis/auto',
          icon: 'directions_car',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Habitation',
          link: '/devis/habitation',
          icon: 'home',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Voyage',
          link: '/devis/voyage',
          icon: 'airplanemode_active',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Santé',
          link: '/devis/sante',
          icon: 'local_hospital',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Vie',
          link: '/devis/vie',
          icon: 'favorite',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Assur+',
          link: '/plus',
          icon: 'plus',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      //Simulation menu
      SimulationItems: [
        {
          title: 'Auto/Moto',
          link: '/devis/auto',
          icon: 'directions_car',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      DevisItems1: [
        {
          title: 'Devis',
          link: '/devis',
          icon: 'subject',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      //Assurance menu
      AssuranceItems: [
        {
          title: 'Auto/Moto',
          link: '/assurance/Auto-Moto',
          icon: 'directions_car',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Habitation',
          link: '/assurance/Habitation',
          icon: 'home',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Voyage',
          link: '/assurance/Voyage',
          icon: 'airplanemode_active',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Santé',
          link: '/assurance/Sante',
          icon: 'local_hospital',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Vie',
          link: '/assurance/vie',
          icon: 'favorite',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Assur+',
          link: '/assurance/Assurplus',
          icon: 'favorite',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Sinistres',
          link: '/assurance/sinistre',
          icon: 'favorite',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      createdAcount: false,
      recoveryPassword: false,
      ServerRep: null,
      step: 0,
      alert: false,
      message: {
        type: null,
        texte: null
      },
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      }, // Customized options for success toast
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'error'
      }, // Customized options for error toast
      userLogin: {
        email: '',
        password: ''
      },
      userRegister: {
        email: '',
        password: '',
        confirmPass: '',
        telephone: '',
        nom: '',
        prenom: ''
      },
      devisIcon: [
        {
          autoImage: '../assets/img/icones/menu/mrp_quote.png'
        },
        {
          autoImage: '../assets/img/icones/menu/mrp_quote.png'
        },
        {
          autoImage: '../assets/img/icones/menu/mrp_quote.png'
        }
      ]
    };
  },

  created() {
    this.fetchEventsList();
    this.timer = setInterval(this.fetchEventsList, 60000);
    this.timer3 = setInterval(this.checkContratAFinaliser, 1000);
  },

  methods: {
    toSinistre() {
      if (!this.$store.state.isUserLoggedIn) {
        this.showLoginForm = true;
      } else {
        this.$router.go(this.$router.push('/sinistre'));
      }
    },
    showEntityHealthFunction() {
      this.showEntityHealth = !this.showEntityHealth;
    },
    showEntityInsurancesFunction() {
      this.showEntityInsurances = !this.showEntityInsurances;
    },
    goToHome() {
      this.$router.push('/');
      this.sideNav = false;
    },
    goToSimAuto() {
      this.$router.push('/simulate/devis/auto');
    },
    checkToken() {
      Api()
        .get('user/check/token')
        .then((resultat) => {
          if (resultat.data.ok === true) {
            console.log('ok');
          } else {
            store.state.isUserLoggedIn = false;
            store.dispatch('setUser', {});
            store.dispatch('setToken', {});
          }
        })
        .catch((err) => {
          if (err.response.data.ok === false) {
            store.state.isUserLoggedIn = false;
            store.dispatch('setUser', {});
            store.dispatch('setToken', {});
          }
        });
    },
    allowWhatsapp() {
      if (screen.width <= 768) {
        this.isMobileWhatsapp = true;
        this.isDesktopWhatsapp = false;
      } else {
        this.isMobileWhatsapp = false;
        this.isDesktopWhatsapp = true;
      }
    },
    selectCountry() {
      Api()
        .post('partenaires/set/selected', { pays: 'Senegal', societe: 'SNSAAS Assuraf Cleo' })
        .then((resultat) => {
          this.$store.dispatch('selectCountry', resultat.data);
          this.$nextTick(() => {});
        })
        .catch((error) => {});
    },

    loadImg(imgPath) {
      return images('./' + imgPath);
    },
    toDevisFlotte() {
      this.closeMenuBurger();
      this.$router.push('/flotte/entreprise/');
    },

    toDevisMrp() {
      this.closeMenuBurger();
      this.$router.push('/devis/mrp/');
    },
    toDevisTrc() {
      this.closeMenuBurger();
      this.$router.push('/devis/trc/');
    },

    toRcScolaire() {
      this.closeMenuBurger();
      this.$router.push('/rcscolaire/');
    },

    allowSinitre() {
      const currentUrl = this.$router.currentRoute.name;
      if (currentUrl == 'sinistre') {
        this.allowIconSinitre = false;
      } else {
        this.allowIconSinitre = true;
      }
    },
    toSinistre() {
      if (!this.$store.state.isUserLoggedIn) {
        this.showLoginForm = true;
      } else {
        this.$router.push('/sinistre');
      }
    },
    updateLanguage() {
      const locale = String(this.$i18n.locale || 'FR')
        .trim()
        .toUpperCase()
        .startsWith('EN')
        ? 'EN'
        : 'FR';
      this.$i18n.locale = locale;
      sessionStorage.setItem('locale', locale);
    },
    closeMenuBurger() {
      const $menu = $('.menu');
      const $button = $('.menu-button');
      $menu.toggleClass('show');
      const hamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:0px;top:-1px">&#9776;</span>';
      const closeHamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:2px;top:-2px">&#10005;</span>';
      $button.text($menu.hasClass('show') ? '' : '');
      if (!$menu.hasClass('show')) {
        $button.html(hamburgerIcon);
      } else {
        $button.html(closeHamburgerIcon);
      }
    },
    link_menu_onclick(branche) {
      this.closeMenuBurger();

      if (branche == 'Auto/Moto') {
        this.$quoteCreationEntryPoint.entry_point = 'menu';
        localStorage.setItem('quoteCreationEntryPoint', 'menu');
        let GtmVal = {
          branche: 'automobile',
          entry_point: 'menu',
          event: 'quote_creation_intent'
        };
        PushInDataLayer(GtmVal);
      } else if (branche == 'Santé') {
        this.$quoteCreationEntryPoint.entry_point = 'menu';
        localStorage.setItem('quoteCreationEntryPoint', 'menu');
        let GtmVal = {
          branche: 'sante',
          entry_point: 'menu',
          event: 'quote_creation_intent'
        };
        PushInDataLayer(GtmVal);
      } else {
        this.$quoteCreationEntryPoint.entry_point = 'menu';
        localStorage.setItem('quoteCreationEntryPoint', 'menu');
        let GtmVal = {
          branche: branche.toLowerCase(),
          entry_point: 'menu',
          event: 'quote_creation_intent'
        };
        PushInDataLayer(GtmVal);
      }
    },

    ContactEntryPoint(entryPoint) {
      this.closeMenuBurger();
      this.$contactUsEntryPoint.entry_point = entryPoint;
      const val = {
        entry_point: entryPoint,
        event: 'contact_intent'
      };
      PushInDataLayer(val);
    },

    LoadPopupMobileLeft() {
      this.$loginPopupPosition.position = 'mobile-top-left';
      this.$loginPopupPosition.event = 'login';

      const val = {
        position: 'mobile-top-left',
        event: 'login'
      };

      PushInDataLayer(val);
      this.showLoginForm = true;
    },

    LoadPopupMobileRight() {
      this.$loginPopupPosition.position = 'mobile-top-right';
      this.$loginPopupPosition.event = 'login';

      const val = {
        position: 'mobile-top-right',
        event: 'login'
      };
      PushInDataLayer(val);
      this.showLoginForm = true;
    },

    LoadLoginPopupDesktop() {
      this.$loginPopupPosition.position = 'desktop';
      this.$loginPopupPosition.event = 'Sign_up';

      const val = {
        position: this.$loginPopupPosition.position,
        event: this.$loginPopupPosition.position
      };
      PushInDataLayer(val);
      this.showLoginForm = true;
    },

    checkContratAFinaliser() {
      if (this.$store.state.user && this.$store.state.devispayementDiffere) {
        if (!this.Mano) {
          this.Mano = 12;
        }
        this.Mano2 = this.Mano2 + 1;
      } else {
        this.Mano2 = 0;
      }
    },

    fetchEventsList() {
      if (this.Mano > 0) {
        this.Mano = this.Mano - 1;
      }

      if (this.Mano == 0 && this.$store.state.devispayementDiffere) {
        this.$store.dispatch('setDevisPayementDiffere', null);
      }
    },

    RedirectionEspaceAssure() {
      this.closeMenuBurger();
      if (this.$store.state.isUserLoggedIn) {
        this.$router.push('/dashboard');
      } else {
        this.LoadPopupMobileRight();
        //this.showLoginForm = true
      }
    },

    RedirectionPaiemtnDiffere() {
      if (this.verifBranche == 'Autre') {
        this.$router.push('/paiement/differe');
      } else if (this.verifBranche == 'Santé') {
        this.$router.push('/payement/nest/differe');
      }
    },

    isMobile: function () {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },

    isDesktop: function () {
      if (screen.width > 768) {
        return true;
      } else {
        return false;
      }
    },
    isTablette() {
      if (screen.width > 425 && screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },

    async login() {
      const loginResp = await AuthService.login({
        email: this.userLogin.email,
        password: this.userLogin.password
      });

      if (loginResp.data.error) {
        this.alert = true;
        this.message.type = 'error';
        this.message.texte = loginResp.data.error;
        this.userLogin.password = '';
      } else {
        await this.$store.dispatch('setToken', loginResp.data.token);
        await this.$store.dispatch('setUser', loginResp.data);
        this.userLogin = {};
        this.LoginDialog = false;

        const UserForInercom = {
          name: loginResp.data.nom + ' ' + loginResp.data.prenom,
          email: loginResp.data.email,
          Phone: loginResp.data.telephone_port
        };

        localStorage.setItem('InercomName', UserForInercom.name);
        localStorage.setItem('InercomEmail', UserForInercom.email);
        localStorage.setItem('InercomPhone', UserForInercom.Phone);

        if (
          this.$route.path != '/devis/sonac/caution' &&
          this.$route.path != '/individuel' &&
          this.$route.path != '/devis/voyage' &&
          this.$route.path != '/devis/auto' &&
          this.$route.path != '/devis/habitation' &&
          this.$route.path != '/sante/nest' &&
          this.$route.path != '/sante/nest/' &&
          this.$route.path != '/sante/transvie/Entreprise' &&
          this.$route.path != '/sante/transvie/individuel' &&
          this.$route.path != '/sante/kermel/famille' &&
          this.$route.path != '/simulate/devis/auto' &&
          this.$route.path != '/simulate/devis/liste' &&
          this.$route.path != '/sante/kermel/suivi'
        ) {
          window.location.reload();
        }
      }
    },

    /*===LOGIN USER WITH COOKIES INFORMATIONS===*/
    login_With_Cookies() {
      const login = document.cookie.match(new RegExp('(^| )ULI=([^;]+)'));
      if (typeof login == 'object' && login != null) {
        this.userLogin.email = decodeURIComponent(login[2]);
      }
    },

    async register() {
      const response = await AuthService.signup({
        email: this.userRegister.email,
        password: this.userRegister.password,
        confirmPass: this.userRegister.confirmPass,
        telephone_port: this.userRegister.telephone,
        nom: this.userRegister.nom,
        prenom: this.userRegister.prenom,
        role: 'User',
        etat: 'Online'
      });
      if (response.statusText === 'OK') {
        const resp = await AuthService.login({
          email: this.userRegister.email,
          password: this.userRegister.password
        });

        await this.$store.dispatch('setToken', resp.data.token);
        await this.$store.dispatch('setUser', resp.data); // on avait : resp.data.user 'user' n'existait pas; tout le contenu se trouve dans data

        const UserForInercom = {
          name: this.userRegister.nom + ' ' + this.userRegister.prenom,
          email: this.userRegister.email,
          Phone: this.userRegister.telephone
        };

        this.alert = true;
        this.message.texte = 'User created'; // response.data.message
        this.message.type = 'success'; // ça n'existait pas je l'ai fixé pour le moment
        this.userRegister = {};
        this.LoginDialog = false;

        localStorage.setItem('InercomName', UserForInercom.name);
        localStorage.setItem('InercomEmail', UserForInercom.email);
        localStorage.setItem('InercomPhone', UserForInercom.Phone);

        if (
          this.$route.path != '/devis/sonac/caution' &&
          this.$route.path != '/individuel' &&
          this.$route.path != '/devis/voyage' &&
          this.$route.path != '/devis/auto' &&
          this.$route.path != '/devis/habitation' &&
          this.$route.path != '/sante/nest' &&
          this.$route.path != '/sante/nest/' &&
          this.$route.path != '/sante/transvie/Entreprise' &&
          this.$route.path != '/sante/transvie/individuel' &&
          this.$route.path != '/sante/kermel/famille' &&
          this.$route.path != '/simulate/devis/auto' &&
          this.$route.path != '/simulate/devis/liste' &&
          this.$route.path != '/sante/kermel/suivi'
        ) {
          window.location.reload();
        }
      }
    },

    userUpdatePassword: function () {
      if (this.password_new) {
        const params = {
          email: this.password_new
        };
        Api()
          .post('user/resetpassword', params)
          .then((response) => {
            this.ServerRep = response.status;
          });
      } else {
        this.$toasted.show('Votre adresse email est obligatoire ', this.ToastTabError);
      }
    },

    scrollMeTo(refName) {
      const element = this.$refs[refName];
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },

    toDashboard() {
      this.$router.push('/dashboard');
    },

    ContactForm() {
      let routetoContact = !this.$router.currentRoute;
      if (routetoContact) {
      }
    },

    StorageRemover() {
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setDevis', null);
      this.$store.dispatch('setDevisPayement', null);
      this.$store.dispatch('setDevisPayementDiffere', null);
      this.$store.dispatch('setuser_quote_count', null);
      this.$store.dispatch('setuser_contract_count', null);

      localStorage.removeItem('canal');
      localStorage.removeItem('numdevis');
      localStorage.removeItem('amount');
      localStorage.removeItem('adressliv');
      localStorage.removeItem('Callback');
      localStorage.removeItem('passenger-birthady-age');
      localStorage.removeItem('loic');
      localStorage.removeItem('papa');
      localStorage.removeItem('UserArray');
      localStorage.removeItem('PaymentlinkId');
      localStorage.removeItem('InercomName');
      localStorage.removeItem('InercomEmail');
      localStorage.removeItem('InercomPhone');
      localStorage.removeItem('seturlapi');
      localStorage.removeItem('item_list_name');
      localStorage.removeItem('EcommercePushed');
      localStorage.setItem('isLogged', false);
      localStorage.removeItem('vuex');
    },

    logout() {
      Api()
        .get('user/logout/' + store.state.user._id)
        .then((resp) => {
          if (resp) {
            this.StorageRemover();
          } else {
            this.StorageRemover();
          }
        })
        .catch((err) => {
          this.StorageRemover();
        });

      //if(this.$route.path!="/"){
      this.$router.push('/');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      //}
    },

    gotoprofile() {
      this.$router.push('/profil');
    }
  },
  computed: {
    ...mapGetters(['username']),
    isWhatsappExcludedPage() {
      const excluded = ['/aywa', '/dem', '/tukki']
      return excluded.some(p => this.$route.path.startsWith(p))
    },
    whatsappFloatStyle() {
      if (this.isWhatsappExcludedPage) {
        return { marginTop: '50px' }
      }
      return {}
    }
  },
  watch: {
    ServerRep() {
      if (this.ServerRep == 200) {
        this.$toasted.show(
          'Un lien vous a été envoyé par mail pour mettre a jour votre mots de passe !',
          this.ToastTabSucess
        );
        this.recoveryPassword = false;
      } else {
        this.$toasted.show("Le lien de modification n'a pas pu être envoyé!", this.ToastTabError);
      }
    }
  },
  mounted() {
    $(function () {
      const $menu = $('.menu');
      const $button = $('.menu-button');
      const hamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:0px;top:-1px">&#9776;</span>';
      const closeHamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:2px;top:-1px">&#10005;</span>';
      $button.on('click', function () {
        $menu.toggleClass('show');
        $button.text($menu.hasClass('show') ? '' : '');
        if (!$menu.hasClass('show')) {
          $button.html(hamburgerIcon);
        } else {
          $button.html(closeHamburgerIcon);
        }
      });

      // Initial state
      if (!$menu.hasClass('show')) {
        $button.html(hamburgerIcon);
      }
    });

    this.checkToken();
    this.allowWhatsapp();
    if (
      this.$store.state.apikey != '' &&
      this.$store.state.apikey != null &&
      this.$store.state.paraphrase != '' &&
      this.$store.state.paraphrase != null
    ) {
      $('#select_menu')
        .focus(function () {
          $('option').each(function () {
            $(this).html($(this).data('display'));
          });
        })
        .on('change', function () {
          $('option').each(function () {
            $(this).html($(this).val());
          });
          $(this).blur();
        });

      if (sessionStorage.getItem('locale')) {
        this.$i18n.locale = sessionStorage.getItem('locale');
      } else {
        sessionStorage.setItem('locale', this.$i18n.locale);
      }
      this.allowSinitre();
    } else {
      if (sessionStorage.getItem('locale')) {
        this.$i18n.locale = sessionStorage.getItem('locale');
      } else {
        sessionStorage.setItem('locale', this.$i18n.locale);
      }
      // this.selectCountry()
    }
  }
};
</script>

<style scoped>
.popup-login-title {
  background: #fff;
  color: #ffa409;
  text-align: center !important;
}

.login-btn {
  background: #fff;
  color: #ffa409;
  font-size: 15px;
  border-radius: 20px;
  text-transform: none;
  font-weight: 500;
}

.login-btn-mobile {
  background: rgba(255, 255, 255, 0);
  color: grey;
}

.login-btn-mobile-connect {
  background: rgba(255, 255, 255, 0);
  color: #ffa409;
}

.toOpac {
  background: rgba(255, 255, 255);
  z-index: 1000;
  border-radius: 8px;
}

.toOpac:hover {
  background: white;
}

.link-a {
  color: black;
  /*z-index: 9999;*/
}

.to-grey {
  color: #585858;
  text-transform: none;
  font-weight: 500;
}

.text-assuraf {
  color: #ffa409;
}

#menu {
  border-bottom-left-radius: 8px;
  color: #fff;
  transition: 0.8s;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
}

.tile:active {
  background: #ffa409;
  color: #fff;
}

.theme--light.v-icon {
  color: #ffa409;
}

.v-list .v-list__tile--active {
  color: #ffa409;
}

.v-list__tile__action:first-of-type .v-icon {
  color: #ffa409;
}

.to_left {
  margin-left: -10px;
}

.icon-menu {
  font-size: 25px;
}

a {
  color: inherit;
  text-decoration: none;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

li a {
  color: black;
}

li:hover {
  color: #ffa409;
  cursor: pointer;
}

ul li ul {
  visibility: visible;
  opacity: 0;
  margin-top: -3rem;
  display: none;
}

ul li:hover > ul,
ul li ul:hover {
  visibility: visible;
  opacity: 1;
  display: flex;

  transition:
    all 0.3s ease-in-out 0s,
    visibility 0s linear 0.3s,
    z-index 0s linear 0.01s;
}

#dropdown {
  margin-left: 20%;
}

#disable {
  pointer-events: none;
}

.policeLato {
  font-family: Lato, 'Helvetica Neue', Arial, sans-serif;
}
.trigger {
  width: 170px;
}

.trigger span {
  width: 200px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 40px;
  /*padding: 0 18px;*/
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition:
    250ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 200px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}
.trigger:hover span {
  /*//min-width: 220px;*/
  border-radius: 22px 22px 0 0;
  transition:
    100ms border-radius 0ms,
    100ms color 100ms,
    350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
  /*//transition: 150ms transform 350ms;*/
}
.trigger:hover ul.devis a {
  opacity: 1;
  /*//transition: 150ms opacity 700ms;*/
}

.trigger-simulation {
  width: 170px;
}

.trigger-simulation span {
  width: 200px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5b94bc;
  color: #000;
  display: block;
  min-width: 0px;
  height: 40px;
  /*padding: 0 18px;*/
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition:
    250ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 200px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}
.trigger-simulation:hover span {
  /*//min-width: 220px;*/
  border-radius: 22px 22px 0 0;
  transition:
    100ms border-radius 0ms,
    100ms color 100ms,
    350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
  /*//transition: 150ms transform 350ms;*/
}
.trigger-simulation:hover ul.devis a {
  opacity: 1;
  /*//transition: 150ms opacity 700ms;*/
}

#Assurance span {
  width: 110px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  color: #585858;
  background: none;
  min-width: 0px;
  height: 34px;
  /*padding: 0 18px;*/
  z-index: 1;
  cursor: pointer;
  transition:
    250ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
#Assurance:hover span {
  /*//min-width: 220px;*/
  border-radius: 22px 22px 0 0;
  transition:
    100ms border-radius 0ms,
    100ms color 100ms,
    350ms min-width 0ms;
  color: #000000;
  background: #e4e4e4;
}
#Assurance ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

#Assurance ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
#Assurance ul.devis li {
  top: 0;
  left: 0;
  width: 110px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
#Assurance ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
#Assurance ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
#Assurance ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
#Assurance ul.devis li:hover {
  border-left: 10px solid #eee;
}

#Assurance:hover ul.devis {
  transform: scaley(1);
  /*//transition: 150ms transform 350ms;*/
}
#Assurance:hover ul.devis a {
  opacity: 1;
  /*//transition: 150ms opacity 700ms;*/
}

/* 
select {
    padding-left: 6%!important;
    color: #ffa409;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
    border: none!important;
    position:absolute;
    margin-top: 15px;;
} */

select {
  background-color: white;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 3.2px 30px 3.2px 8.2px;

  margin: 0;
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
}

select.language {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
  background-position:
    calc(120% - 22px) calc(1em + -2px),
    calc(115% - 15px) calc(1em + -2px),
    calc(100% - 1.5em) 0.2em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat !important;
}

.eazy-audio-player {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  /* width: 100px; */
  text-align: center;
  padding: 6px 15px;
  /* border: 1px solid #dedede; */
  display: block;
  background: #ffa409;
  border-radius: 50%;
  font-size: 190%;
  cursor: pointer;
}
.eazy-audio-player i {
  display: inline-block;
  color: #33475c;
  font-size: 25px;
}

.eazy-audio-player span {
  display: inline-block;
  min-width: 25px;
}

#floating_bouton {
  position: fixed;
  right: 10px;
  bottom: 165px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton :hover {
  transform: scale(1.04);
}

#floating_bouton_mobile {
  position: fixed;
  right: 2px;
  bottom: 115px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton_mobile :hover {
  transform: scale(1.04);
}

#floating_bouton_whatsapp {
  position: fixed;
  right: 10px;
  bottom: 86px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
.floating_bouton_whatsapp {
  position: fixed;
  right: 10px;
  bottom: 20px;
  width: auto;
  transition: transform 0.2s;
  background-color: yellow;
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}

.floating_bouton_whatsapp :hover {
  transform: scale(1.04);
}

#floating_bouton_whatsapp :hover {
  transform: scale(1.04);
}

#floating_bouton_whatsapp_mobile {
  position: fixed;
  right: 2px;
  bottom: 30px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton_whatsapp_mobile :hover {
  transform: scale(1.04);
}

.allowMarginStyle {
  margin-top: 70px !important;
}

.cont {
  line-height: 100px;
  transition: all 0.7s;
  &.hidden {
    height: 0;
    transition: all 0.7s;
  }
}

.showAnimation {
  transition: all 0.7s;
}

.picto-item {
  position: relative; /*les .picto-item deviennent référents*/
  /* cursor: help; */
  border-radius: 50%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* on génère un élément :after lors du survol et du focus :*/

.picto-item:hover:after,
.picto-item:focus:after {
  content: attr(aria-label); /* on affiche aria-label */
  position: absolute;
  top: -2.4em;
  left: 50%;
  transform: translateX(-50%); /* on centre horizontalement  */
  z-index: 2; /* pour s'afficher au dessus des éléments en position relative */
  white-space: nowrap; /* on interdit le retour à la ligne*/
  padding: 5px 14px;
  background: #ffa409;
  color: #2b2b2b;
  border-radius: 4px;
  font-size: 1.2rem;
}

/* on génère un second élément en :before pour la flèche */

[aria-label]:hover:before,
[aria-label]:focus:before {
  content: '▼';
  position: absolute;
  top: -1em;
  left: 50%;
  transform: translateX(-50%); /* on centre horizontalement  */
  font-size: 20px;
  color: #ffa409;
}

/* pas de contour durant le :focus */
[aria-label]:focus {
  outline: none;
}

/* déco */

h1 {
  margin-top: 20px;
  margin-bottom: 40px;
  color: #789;
  text-align: center;
  text-shadow: 1px 1px #fff;
}
p,
.pictos {
  text-align: center;
}

.picto-item {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.2em;
  width: 1.2em;
  height: 1.2em;
  font-weight: 500;
  color: #2b2b2b;
  background: #ffa409;
  font-size: 3rem;
  text-align: center;
  text-decoration: none;
  margin-top: -20px;
}

.container {
  position: relative;
  width: max-content;
  height: max-content;
  /* margin: 40px auto; */
  /* background: #000; */
  /* padding: 20px 20px 60px; */
  border-radius: 10px;
  margin-top: 300px;
}
.container h1,
.container p {
  color: #999;
}
.container .phone {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #bf2626;
  height: 100%;
}
.container .phone .screen {
  padding: 20px;
  flex: 1;
}
.button {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%);
  height: 40px;
  width: 40px;
  background-color: #222;
  border: 1px solid #555;
  border-radius: 50%;
}
.top-bar {
  /* background-color: #258096;
	 padding: 20px;*/
  text-align: right;
}
.top-bar a.menu-button {
  position: relative;
  z-index: 10;
}
.top-bar a.menu-button:link,
.top-bar a.menu-button:visited,
.top-bar a.menu-button:hover,
.top-bar a.menu-button:active {
  color: #ffa409;
  text-decoration: none;
  font-size: 14px;
}

.menu {
  z-index: 1;
}
.menu ul {
  transition: all 0.5s ease-in;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -80%);
}
.menu ul li {
  text-align: center;
  padding: 10px;
}
.menu ul li a {
  color: #fff;
  text-decoration: none;
}
.menu {
  transition: all 0.3s ease-in;
  position: absolute;
  background: #fff;
  top: 50px !important;
  left: 0;
  width: 100%;
  height: 100vh;
  opacity: 0;
  visibility: hidden;
}
.menu.show {
  opacity: 1;
  visibility: visible;
}
.menu.show ul {
  transform: translate(-50%, -50%);
}

.menu.hide {
  opacity: 0;
  visibility: hidden;
}
</style>
